var exports = {
  "r9": "MenuItem.module__disabled___QmZWcS",
  "W$": "MenuItem.module__subtext___QmZWcS",
  "z": "MenuItem.module__sliderItem___QmZWcS",
  "Ry": "MenuItem.module__sliderHeader___QmZWcS",
  "KF": "MenuItem.module__sliderLabel___QmZWcS",
  "rv": "MenuItem.module__sliderValue___QmZWcS",
  "xJ": "MenuItem.module__sliderContainer___QmZWcS",
};

module.exports = exports;
